import { Year } from '../../models/history'

export const getSlides = (
  linksPerSlide: number,
  yearsInfo: Year[]
): Year[][] => {
  const res: Year[][] = [[]]

  let count = 0
  let currentSlideIndex = 0

  for (let i = 0; i < yearsInfo.length; i++) {
    const yearElement = yearsInfo[i]

    if (count < linksPerSlide) {
      ++count
      res[currentSlideIndex].push(yearElement)
    } else {
      // новый слайд начинается с этого элемента, поэтому счётчик равен 1, а не 0
      count = 1
      ++currentSlideIndex

      res.push([])
      res[currentSlideIndex].push(yearElement)
    }
  }

  return res
}

export const getYearImage = (year: number, activeYear: number) =>
  year === activeYear
    ? "/static/images/circles.svg"
    : "/static/images/circles-inactive.svg"
